import React, { useEffect } from "react";
import { RevolvingDot } from "react-loader-spinner";
import './loader.css';

const Loader = ({ isLoading }) => {
  useEffect(() => {
    if (isLoading) {
      // window.scrollTo(0, 0); // جابجایی به بالای صفحه
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    // پاک کردن تغییرات در هنگام حذف کامپوننت
    return () =>  document.body.style.overflow = 'auto';
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="dot-loader">
      <RevolvingDot
        visible={true}
        height="50"
        width="50"
        color="#00a14b"
        animationDuration="0.5"
        ariaLabel="revolving-dot-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default Loader;
